
const GetSaveTilesOrderReducer = (state = { type: 'LOADING_SAVE_TILES_ORDER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SAVE_TILES_ORDER_ACTION':
            return action
        default:
            return state
    }
}

const GetResetToDefaultTilesOrderReducer = (state = { type: 'LOADING_RESET_TO_DEFAULT_TILES_ORDER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION':
            return action
        default:
            return state
    }
}


export {
    GetSaveTilesOrderReducer,
    GetResetToDefaultTilesOrderReducer
}